import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Flex } from "@radix-ui/themes";
import Lowlight from "react-lowlight";
import styled from "@emotion/styled";
import { atlasRoutes } from "@/app/router/routes";

export const SessionArtifactViewPage: FC = () => {
  const navigate = useNavigate();
  const { artifactId } = useParams<{ artifactId: Uuid }>();

  if (!artifactId) return <div>Invalid ID</div>;

  const result = useQuery({
    queryKey: ["session-artifact-by-id", artifactId],
    queryFn: () =>
      api.get("/internal/v1/sessions/artifacts/{artifact_id}", {
        params: { path: { artifact_id: artifactId } },
      }),
    staleTime: 60 * 1000,
  });

  const handleViewSession = () => {
    const sessionId = result.data?.data?.session_id;
    if (!sessionId) return alert("No session id on artifact.");
    navigate(atlasRoutes.sessionEvents({ params: { sessionId } }).path);
  };

  if (result.isLoading) return <div>Loading...</div>;
  if (result.isError || !result.data) return <div>Error: {result.error?.message}</div>;

  return (
    <Container>
      <ButtonGroup>
        <Button variant="soft" onClick={handleViewSession}>
          View Session Events
        </Button>
      </ButtonGroup>
      <h1>Session Artifact</h1>
      <Lowlight language="json" value={JSON.stringify(result.data, null, 2)} markers={[]} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 20px;
`;

const ButtonGroup = styled(Flex)`
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;
